import React, { useMemo, useState } from "react";
import Icons from "../../Constants/Icons";
import Colors from "../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const UpcomingEventsScreen = ({
  data,
  handelEnabled,
  adminEventEdit,
  onClickFeaturedStatus,
  masterEvent,
  onCancelSession,
  cancel = true,
}) => {
  const navigate = useNavigate();
  const [openSession, setOpenSession] = useState(null);
  const onClickEventDetails = (item) => {
    navigate("/EventDetails", {
      state: {
        eventId: item.eventId,
      },
    });
  };
  const handleEditClick = (item) => {
    navigate("/EventUpdate", {
      state: {
        eventId: item.eventId,
        eventTypeId: item.eventTypeId,
        adminEventEdit: adminEventEdit,
      },
    });
  };
  const handleRepeatEventClick = (item) => {
    navigate("/EventRepeat", {
      state: {
        eventId: item.eventId,
        adminEventRepeat: true,
      },
    });
  };
  const handleSubMasterEvent = (item) => {
    navigate(`/SubMasterEvents/${item.eventId}`, {
      state: {
        eventId: item.eventId,
      },
    });
  };
  const groupedEvents = useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }
    const groups = new Map();
    data.forEach((item, index) => {
      const hasSession =
        item.eventSession !== null &&
        item.eventSession !== undefined &&
        item.eventSession !== "";

      const groupKey = hasSession
        ? `session-${item.eventSession}`
        : `event-${item.eventId || index}`;

      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          key: groupKey,

          eventSession: hasSession ? item.eventSession : null,

          mainEvent: item,

          events: [],
        });
      }

      groups.get(groupKey).events.push(item);
    });

    return Array.from(groups.values());
  }, [data]);
  const toggleSession = (groupKey) => {
    setOpenSession((previous) => (previous === groupKey ? null : groupKey));
  };

  const columns = [
    { label: "", className: "w-8" },
    { label: "Event Type", className: "w-10" },
    { label: "Event Name", className: "w-22" },
    { label: "Date & Location", className: "w-30" },
    { label: "Actions", className: "w-10" },
    { label: "Status", className: "w-10" },
    { label: "Featured", className: "w-10" },
  ];
  const renderSessionBanner = (group) => {
    const isOpen = openSession === group.key;
    return (
      <div
        onClick={() => toggleSession(group.key)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",

          cursor: "pointer",
          userSelect: "none",

          padding: "16px 14px",
          margin: "10px 10px 0 10px",

          borderRadius: "8px",

          background: "rgba(6, 101, 228, 0.3)",

          transition: "background-color 0.15s ease, border-color 0.15s ease",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              fontSize: "15px",
              fontWeight: 700,
              color: "white",
            }}
          >
            Session {group.eventSession}
          </span>

          <span
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: group.status === "Cancelled" ? "#ff4d4f" : "#fff",
            }}
          >
            {group.status === "Cancelled"
              ? "Cancelled"
              : `(${group.events.length} events)`}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span
            onClick={(e) => {
              e.stopPropagation();
              onCancelSession?.(group);
            }}
            style={{
              width: "30px",
              height: "30px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "red",
              cursor: "pointer",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          <span
            style={{
              width: "20px",
              height: "20px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",

              borderRadius: "5px",
              // background: isOpen ? "#175CD3" : "#98A2B3",
              color: "#fff",

              transition: "transform 0.2s ease, background-color 0.15s ease",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <svg width="12" height="12" viewBox="0 0 10 6" fill="none">
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
    );
  };
  const renderEventRow = (item, index) => {
    return (
      <div key={item.eventId || `event-${index}`}>
        <div
          className="achievement-stretch-row"
          style={{ gap: "12px", padding: "14px 18px" }}
        >
          <div className="lastWeekEndDivGreyColor w-8">
            <img
              src={item.eventImages ?? Icons.ic_AY_logo}
              alt=""
              className="subcategory-input"
              style={{
                cursor: "auto",
                objectFit: "contain",
              }}
            />
          </div>
          <div className="fontSize16WithoutFlex w-10">{item.eventTypeName}</div>
          <div
            className="w-22"
            style={{
              paddingLeft: 0,
            }}
          >
            <div
              style={{
                paddingRight: 18,
                wordBreak: "break-word",
              }}
              className="fontSize16WithoutFlex"
            >
              {item.eventName}
            </div>
          </div>

          <div
            className="w-30"
            style={{
              paddingLeft: 0,
            }}
          >
            <div className="achievement-title">
              <img className="icon_style_list" alt="" src={Icons.ic_calendar} />

              <div className="itemTextDisplay">
                {moment(
                  `${item.eventStartDate} ${item.eventStartTime}`,
                  "DD/MM/YYYY HH:mm:ss",
                ).format("dddd, DD MMM YYYY, hh:mm A")}
              </div>
            </div>

            <div className="achievement-title">
              <img className="icon_style_list" alt="" src={Icons.ic_location} />

              <div
                style={{
                  paddingRight: 18,
                }}
                className="itemTextDisplay"
              >
                {item.venueAddress}
              </div>
            </div>
          </div>
          <div
            style={{
              gap: "12px",
              display: "flex",
            }}
            className="w-10"
          >
            <img
              src={Icons.event_eye}
              alt=""
              onClick={() => onClickEventDetails(item)}
              className="edit-button pointer"
            />

            {/* EDIT */}

            <img
              src={Icons.edit}
              alt=""
              onClick={() => handleEditClick(item)}
              className="edit-button pointer"
            />
          </div>

          <div className="fontSize16WithoutFlex w-10">
            <div className="user_Status pointer">
              <button
                onClick={() => handelEnabled(item, index)}
                className="button"
                style={{
                  cursor: "pointer",

                  backgroundColor: item.isEnabled
                    ? Colors.mainGreen01
                    : Colors.mainRed01,

                  color: item.isEnabled ? Colors.darkGreen : Colors.darkRed,
                }}
              >
                {item.isEnabled ? "Activate" : "Deactivate"}
              </button>
            </div>
          </div>

          {cancel && (
            <div style={{}} className="fontSize16WithoutFlex w-10">
              <div className="user_Status pointer">
                <button
                  className={`button ${
                    item.isCancel ? "btn-red-no" : "btn-green-yes"
                  }`}
                >
                  {item.isCancel ? "Canceled" : "Active"}
                </button>
              </div>
            </div>
          )}

          <div className="fontSize16WithoutFlex w-10">
            <div className="user_Status pointer">
              <button
                onClick={() => onClickFeaturedStatus(item, index)}
                className="button"
                style={{
                  cursor: "pointer",

                  backgroundColor: item.isFeatured
                    ? Colors.mainGreen01
                    : Colors.mainRed01,

                  color: item.isFeatured ? Colors.darkGreen : Colors.darkRed,
                }}
              >
                {item.isFeatured ? "Activate" : "Deactivate"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <div style={{ maxHeight: "500px" }} className="scrollable-container">
        {groupedEvents.map((group) => {
          const { mainEvent, events, key } = group;
          const hasMultipleEvents = events.length > 1;
          const isOpen = openSession === key;
          if (!hasMultipleEvents) {
            return (
              <React.Fragment key={key}>
                {renderEventRow(mainEvent, 0)}
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={key}>
              {renderSessionBanner(group)}

              {(isOpen ? events : [mainEvent]).map((evt, evtIndex) => (
                <React.Fragment key={evt.eventId || `${key}-${evtIndex}`}>
                  {renderEventRow(evt, evtIndex)}
                </React.Fragment>
              ))}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingEventsScreen;